module.exports = __webpack_public_path__ + "static/img/15.7dd58a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/15.png
// module id = Xy3I
// module chunks = 0